import React from "react";
import "./loader.css";
import { Loading as LoadingSVG } from "../../assets";

const Loader = () => {
  return (
    <div className="loader-container">
      <LoadingSVG id="loading-spinner" />
    </div>
  );
};

export default Loader;
